<style lang="less" scoped>
  .layout {
    background: #f5f7f9;
    position: absolute;
    overflow: hidden;
    min-width: 1200px;
    width: 100%;
    height: 100%;
    .layout-ceiling {
      line-height: 30px;
      background: #464c5b;
      padding: 10px 0;
      overflow: hidden;
      max-height: 50px;
      width: 100%;
      display: inline-flex;
      justify-content: space-between;
      .layout-ceiling-left {
        display: inline-flex;
        .logo-box {
          display: block;
        }
      }
      .layout-ceiling-main {}
      a,
      i {
        padding: 0 5px;
        color: #9ba7b5;
      }
      a:hover,
      i:hover {
        color: #f2f2f2;
      }
    }
  }

  .layout-main {
    height: ~"calc(100% - 50px)";
    .layout-left-menu {
      float: left;
      position: relative;
      height: 100%;
      .ivu-menu {
        height: 100%;
        overflow-y: auto;
      }
      /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
      ::-webkit-scrollbar {
        width: 5px;
        height: 5px;
        background-divor: #f5f5f5;
      }
      /*定义滚动条轨道 内阴影+圆角*/
      ::-webkit-scrollbar-track {
        display: none;
      }
      /*定义滑块 内阴影+圆角*/
      ::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.3);
        background-divor: #555;
      }
      .layout-hide {
        text-algin: center;
      }
    }
    .layout-content {
      height: 100%;
      overflow-y: auto;
    }
  }
</style>
<template>
  <div class="layout">
    <div class="layout-ceiling">
      <div class="layout-ceiling-left">
        <!-- <a class="logo-box text-c c-h" href="#/">
                    <Icon type="home" divor="white"></Icon>
                </a>
                <div class="frame-ctrl text-c">
                    <Icon :type="frame.layout?'android-more-horizontal':'android-more-vertical'" class="p-5 c-h" divor="white" @click.native="setFrame(1)"></Icon>
                    <Icon :type="frame.theme=='dark'?'ios-information':'ios-information-outline'" class="m-l-20 p-5 c-h" divor="white" @click.native="setFrame(2)"></Icon>
                </div> -->
        <div class="logo-box text-c c-h f-14 p-r-20 p-l-10">
          <a href="#/">{{config.baseJson.title}} - {{config.baseJson.subtitle}}</a>
        </div>
      </div>
      <div class="layout-ceiling-main m-r-15 text-r">
        <a>
          <Icon :type="frame.theme=='dark'?'ios-information':'ios-information-circle-outline'" class="m-l-20 p-5 c-h" divor="white" @click.native="setFrame(2)"></Icon>
        </a>
        <a>{{sysUser.branch?sysUser.branch.name:''}}</a> |
        <a href="#/system/user/userCenter">{{sysUser.regName}}<span v-show="sysUser.name">({{sysUser.name}})</span></a> |
        <a v-on:click="loginOut">注销</a> |
        <router-link :to="{ path: '/system/help/controlProblem'}" replace>控件安装</router-link>
      </div>
    </div>
    <div class="layout-main">
      <div class="layout-left-menu" :style="{width:frame.layout?'200px':'300px'}">
        <Menu :theme="frame.theme" width="auto" :open-names="breadcrumb.category" :active-name="breadcrumb.page">
          <Submenu v-for="(item,index) in menu" :key="index" :name="item.url + index">
            <template slot="title">
              <Icon :type="item.icon" size="16"></Icon>
              <i :class="item.icon"></i>
              <span>{{item.title}}</span>
            </template>
            <Menu-item :name="node.url + index + nodeIndex" v-for="(node,nodeIndex) in item.children" :key="node.url" @click.native="goUrl(node,item)" v-if="node.menu==undefined||node.menu">{{node.title}}</Menu-item>
          </Submenu>
        </Menu>
      </div>
      <div class="layout-content pull-l" :style="{width:frame.layout?'calc(100% - 200px)':'calc(100% - 300px)'}">
        <div class="p-10">
          <Breadcrumb>
            <Breadcrumb-item href="/">
              <Icon type="ios-home-outline"></Icon> 首页
            </Breadcrumb-item>
            <Breadcrumb-item :href="item.fullPath" v-for="item in breadcrumb.list" v-if="item.meta.title" :key="item.fullPath">
              <Icon type="logo-buffer"></Icon> {{item.meta.title}}
            </Breadcrumb-item>
          </Breadcrumb>
        </div>
        <div>
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapState } from "vuex";
  export default {
    data() {
      return {
        fullPath: this.$route.fullPath
      };
    },
    computed: {
      ...mapState({
        sysUser: state => state.sysUser.sysUser,
        menu: state => {
          const menu = []
          state.sysUser.menu.forEach(item => {
            if(!item.children.every(item => item.menu == false)) {
              menu.push(item)
            }
          })
          return menu
        },
        breadcrumb: state => state.ivew.breadcrumb,
        frame: state => state.ivew.frame,
        config: state => state.ivew.config
      })
    },
    methods: {
      loginOut() {
        this.$store.commit("sysUser/SET_USER_LOGIN_OUT");
        this.$router.push({
          path: "/system/login",
          query: { redirect: this.fullPath }
        });
      },
      goUrl(node, item) {
        this.$router.push({
          path: "/system/" + item.url + "/" + node.url,
          query: node.query,
          param: node.param
        });
      },
      setFrame(type) {
        this.$store.commit("ivew/SET_FRAME_STORAGE_DATA", {
          layout: type == 1 ? !this.frame.layout : this.frame.layout,
          theme: type == 2 ? this.frame.theme == "dark" ? "light" : "dark" : this.frame.theme
        });
      }
    }
  };
</script>